import { useMemo } from "react"
import { Empty, Flex, Spin } from "antd"
import CampaignTable from "./CampaignTable"
import NotDataWarning from "../../../ui/NotDataWarning"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { IPlacementDataForUpdate } from "../store/types/placements"
import { buildProjectGroups } from "../services/projectGroups.service"
import ProjectGroupList from "../../../components/ProjectGroups/ProjectGroupList"

interface ProjectGroupsProps {
  isExpandedAll: boolean
  setSelectedCampaignIds: React.Dispatch<React.SetStateAction<number[]>>
  selectedCampaignIds: number[]
  placementDataForUpdate: IPlacementDataForUpdate[]
  setPlacementsDataForUpdate: React.Dispatch<React.SetStateAction<IPlacementDataForUpdate[]>>
  minLimitedCPCByCampaignIdMap: Record<string, number>
  setMinLimitedCPCByCampaignIdMap: React.Dispatch<React.SetStateAction<Record<string, number>>>
}

const ProjectGroups: React.FC<ProjectGroupsProps> = (props) => {
  const { isExpandedAll } = props
  const { campaignData, isLoading } = useTypedSelector((select) => select.sponsoredProductsSKC)

  const groups = useMemo(
    () => buildProjectGroups(campaignData.campaigns || []),
    [campaignData.campaigns]
  )

  if (isLoading && groups.length === 0) {
    return (
      <Flex justify="center" style={{ padding: 40 }}>
        <Spin />
      </Flex>
    )
  }

  if (!isLoading && groups.length === 0) {
    return (
      <Flex justify="center" style={{ padding: 40 }}>
        <Empty description="No campaigns" />
      </Flex>
    )
  }

  return (
    <Flex vertical gap={10}>
      {campaignData.lastDateWithoutData ? (
        <NotDataWarning date={campaignData.lastDateWithoutData} />
      ) : null}
      <ProjectGroupList
        groups={groups}
        isExpandedAll={isExpandedAll}
        renderGroupContent={(group) => <CampaignTable {...props} campaigns={group.campaigns} />}
      />
    </Flex>
  )
}

export default ProjectGroups
